import { Typography } from '@material-ui/core';
import React from 'react';

export const ScheduleHourTitleView = ({ hour }) => (
  <Typography style={{fontWeight: '600'}} variant="subtitle2">{hour.format('HH')}</Typography>
);
